import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../../utils/classNames";

import "./index.scss";

export default function ChatPinnedSummary({
    icon,
    title,
    subtitle,
    actionLabel,
    onAction,
    actionProps,
    className,
}) {
    const { className: actionClassName, type, ...restActionProps } = actionProps || {};

    return (
        <div className={classNames("chat-conversation__pinned-summary", className)}>
            <div className="chat-conversation__summary-icon" aria-hidden="true">
                {icon}
            </div>
            <div className="chat-conversation__summary-copy">
                {title ? <p>{title}</p> : null}
                {subtitle ? <span>{subtitle}</span> : null}
            </div>
            {actionLabel ? (
                <button
                    type={type ?? "button"}
                    className={classNames("chat-conversation__summary-action", actionClassName)}
                    onClick={onAction}
                    {...restActionProps}
                >
                    {actionLabel}
                </button>
            ) : null}
        </div>
    );
}

ChatPinnedSummary.propTypes = {
    icon: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    actionLabel: PropTypes.string,
    onAction: PropTypes.func,
    actionProps: PropTypes.object,
    className: PropTypes.string,
};

ChatPinnedSummary.defaultProps = {
    subtitle: "",
    actionLabel: undefined,
    onAction: undefined,
    actionProps: undefined,
    className: undefined,
};
